import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import { SeoManager } from "./components/SeoManager";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsApp";
import { MobileActionBar } from "./components/MobileActionBar";
import Home from "./pages/Home";
import Occasions from "./pages/Occasions";
import CarDetail from "./pages/CarDetail";
import Contact from "./pages/Contact";
import Over from "./pages/Over";
import Afspraak from "./pages/Afspraak";
import Werkplaats from "./pages/Werkplaats";
import Avia from "./pages/Avia";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import { CookieConsent } from "./components/CookieConsent";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = window.__stoofLenis;
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
      requestAnimationFrame(() => lenis.resize());
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <div className="h-14 md:hidden" aria-hidden="true" />
    <WhatsAppButton />
    <MobileActionBar />
  </>
);

const AppRouter = () => {
  // Synchroon op URL-fragment controleren (vóór eerste render) voorkomt race conditions
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/occasions" element={<PublicLayout><Occasions /></PublicLayout>} />
      <Route path="/occasions/:id" element={<PublicLayout><CarDetail /></PublicLayout>} />
      <Route path="/over-ons" element={<PublicLayout><Over /></PublicLayout>} />
      <Route path="/afspraak" element={<PublicLayout><Afspraak /></PublicLayout>} />
      <Route path="/werkplaats" element={<PublicLayout><Werkplaats /></PublicLayout>} />
      <Route path="/avia" element={<PublicLayout><Avia /></PublicLayout>} />
      <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__stoofLenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__stoofLenis;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
          <ScrollTop />
          <SeoManager />
          <Toaster position="top-center" richColors />
          <CookieConsent />
          <AppRouter />
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
